<script lang="ts">
  import { apiTokenValue, botInfo } from "../store";
  import Feedback from "../Feedback.svelte";
  import { sendFeedBack, type AssistantFeedback } from "../service/service";
  import logoIcon from "../assets/images/logo.icon.svg";
  import Logo from "../Logo.svelte";
  export let assistantMessageId: string | null = null;
  export let assistantFeedback: AssistantFeedback | null = null;
  export let role: string;
  export let content: string;
  export let aiMessageConverter: any;
  export let userMessageConverter: any;
  export let expanded: boolean;
  let currentFeedback: "good" | "bad" | "unknown" = "unknown";

  async function sendFeedback(assistantMessageId: string | null, isPositive: boolean) {
    if (!assistantMessageId) return;
    currentFeedback = isPositive ? "good" : "bad";
    const result = await sendFeedBack(assistantMessageId, isPositive, $apiTokenValue);
  }
</script>

<div
  class={`concierge-chat-box-message-container ${role === "user" ? "concierge-right-aligned" : "concierge-left-aligned"}`}
>
  {#if role !== "user"}
    <span
      class="concierge-chat-box-message-assistant-icon"
      style="--assistant-stroke-color: {$botInfo?.settings?.widgetAppearanceBehavior
        ?.widgetAssistantAvatarStrokeColor || '#eaeaea'};"
    >
      {#if $botInfo?.settings?.botImageUrl}
        <img src={$botInfo?.settings?.botImageUrl} alt="logo" />
      {:else}
        <Logo strokeColor={"#0e3c26"} width={"26"} height={"26"} />
      {/if}
    </span>
  {/if}
  <div
    class={`concierge-chat-single-message ${role === "user" ? "concierge-chat-user-message" : "concierge-chat-assistant-message"}`}
    class:concierge-chat-single-message-expanded={expanded}
  >
    <div
      class={`concierge-message-content ${role === "user" ? "concierge-message-content-user" : "concierge-message-content-assistant"}`}
      style="--widget-font-color: {$botInfo?.settings?.widgetAppearanceBehavior?.widgetFontColor ||
        '#000000'};"
    >
      {@html role === "user"
        ? userMessageConverter.makeHtml(content)
        : aiMessageConverter.makeHtml(content)}
    </div>

    {#if role === "assistant" && assistantMessageId && !assistantFeedback}
      <span class={"concierge-message-feedback-container"}>
        {#if ["unknown", "bad"].includes(currentFeedback)}
          <button
            class="concierge-message-feedback-dissatisfied"
            style={"cursor: " + (currentFeedback !== "unknown" ? "unset" : "pointer")}
            on:click={() =>
              currentFeedback === "unknown" && sendFeedback(assistantMessageId, false)}
          >
            <Feedback strokeColor={currentFeedback === "bad" ? "red" : "#8E8E8E"} />
          </button>
        {/if}
        {#if ["unknown", "good"].includes(currentFeedback)}
          <button
            class="concierge-message-feedback-satisfied"
            style={"cursor: " + (currentFeedback !== "unknown" ? "unset" : "pointer")}
            on:click={() => currentFeedback === "unknown" && sendFeedback(assistantMessageId, true)}
          >
            <Feedback strokeColor={currentFeedback === "good" ? "green" : "#8E8E8E"} />
          </button>
        {/if}
      </span>
    {/if}
    {#if role === "assistant" && !!assistantFeedback}
      <span class={"concierge-message-feedback-container"}>
        {#if !assistantFeedback.isPositive}
          <span class="concierge-message-feedback-dissatisfied">
            <Feedback strokeColor={"red"} />
          </span>
        {/if}
        {#if assistantFeedback.isPositive}
          <span class="concierge-message-feedback-satisfied">
            <Feedback strokeColor={"green"} />
          </span>
        {/if}
      </span>
    {/if}
  </div>

  {#if role === "user"}
    <span
      class="concierge-chat-box-message-user-icon"
      style="--avatar-stroke-color: {$botInfo?.settings?.widgetAppearanceBehavior
        ?.widgetUseAvatarStrokeColor || '#eaeaea'};"
    />
  {/if}
</div>

<style>
  /* .concierge-wrapper {
    opacity: 0; 
    animation: fadeIn 1s forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .concierge-wrapper:nth-child(1) {
    animation-delay: 0.2s;
  }
  .concierge-wrapper:nth-child(2) {
    animation-delay: 0.4s;
  }
  .concierge-wrapper:nth-child(3) {
    animation-delay: 0.6s;
  }
  .concierge-wrapper:nth-child(4) {
    animation-delay: 0.8s;
  } */

  .concierge-chat-box-message-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 2px;
    /* margin: 5px 5px 0px 5px; */
    /* margin-top: 30px; */
  }

  /* @media (min-width: 767px) and (max-width: 991px) {
    .concierge-chat-box-message-container {
      margin-top: 25px;
    }
  }
  @media (max-width: 767px) {
    .concierge-chat-box-message-container {
      margin-top: 20px;
    }
  } */
  .concierge-chat-box-message-assistant-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    /* background-color: #eaeaea; */

    border-width: 2px;
    border-style: solid;
    border-color: var(--assistant-stroke-color);
    background-color: transparent;
    margin-top: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .concierge-chat-box-message-assistant-icon img {
    width: 30px;
    height: 30px;
    padding: 1px;
  }

  .concierge-chat-box-message-user-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border-width: 2px;
    border-style: solid;
    border-color: var(--avatar-stroke-color);
    background-color: transparent;
    margin-top: 7px;
    box-sizing: border-box;
  }
  .concierge-left-aligned {
    align-self: flex-start;
  }
  .concierge-right-aligned {
    align-self: flex-end;
  }

  .concierge-message-content {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    font-size: 12px;
    padding: 10px;
    border-radius: 15px;
    font-size: 0.8rem;
    line-height: 20px !important;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
      "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji";
    font-weight: normal;
  }

  .concierge-message-content-user {
    padding-right: 20px;
  }
  .concierge-message-content-assistant {
    padding-left: 20px;
  }
  @media (min-width: 767px) and (max-width: 991px) {
    .concierge-message-content-user {
      padding-right: 15px;
    }
    .concierge-message-content-assistant {
      padding-left: 15px;
    }
  }
  @media (max-width: 767px) {
    .concierge-message-content-user {
      padding-right: 10px;
    }
    .concierge-message-content-assistant {
      padding-left: 10px;
    }
  }
  :global(.concierge-message-content p) {
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 20px;
    white-space: pre-wrap;
    color: #000;
    margin: 0px;
    font-size: 14px;
    font-weight: 500;
    /* font-size: 21px !important; */
  }

  :global(.concierge-message-content-user p, li, ul, h1, h2, h3, h4, h5, h6) {
    color: var(--widget-font-color);
  }

  :global(.concierge-message-content-user a) {
    color: var(--widget-font-color);
    font-weight: 700;
  }

  :global(.concierge-message-content-assistant p, li, ul, h1, h2, h3, h4, h5, h6) {
    color: var(--widget-font-color);
  }

  :global(.concierge-message-content-assistant a) {
    color: var(--widget-font-color);
    font-weight: 700;
  }
  /* Media queries */
  @media (min-width: 767px) and (max-width: 991px) {
    :global(.concierge-message-content p, li, ul, h1, h2, h3, h4, h5, h6) {
      font-size: 16px;
      line-height: 22px;
    }
  }

  @media (min-width: 991px) {
    :global(.concierge-message-content p, li, ul, h1, h2, h3, h4, h5, h6) {
      font-size: 20px;
      line-height: 26px;
    }
  }

  .concierge-chat-single-message {
    flex: 1;
    /* max-width: 290px; */
  }

  .concierge-chat-user-message {
    margin-left: 40px;
    color: #000;
    border-radius: 10px 10px 0px 10px;
  }

  .concierge-chat-assistant-message {
    margin-right: 20px;
    color: #000;
    border-radius: 0px 10px 10px 10px;
  }

  .concierge-message-feedback-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    padding: 10px;
    height: 24px;
    padding-top: 0;
  }

  .concierge-message-feedback-container > button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    outline: none;
    border: none;
    width: 24px !important;
    height: 24px !important;
    cursor: pointer;
    padding: 0px;
    background-color: transparent;
  }
  .concierge-message-feedback-dissatisfied {
    transform: scaleY(-1);
  }
</style>
